class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.lastScrollTop = 0;
    this.ticking = false;
    this.state = null;
  }

  connectedCallback() {
    this.header = document.getElementById('shopify-section-header');
    if (!this.header) return;

    this.headerHeight = this.header.offsetHeight;
    document.documentElement.style.setProperty(
      '--header-height',
      `${this.headerHeight}px`
    );

    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.onResizeHandler = this.updateHeaderHeight.bind(this);

    window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    window.addEventListener('resize', this.onResizeHandler, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
    window.removeEventListener('resize', this.onResizeHandler);
  }

  updateHeaderHeight() {
    this.headerHeight = this.header.offsetHeight;
    document.documentElement.style.setProperty(
      '--header-height',
      `${this.headerHeight}px`
    );
  }

  onScroll() {
    if (this.ticking) return;

    this.ticking = true;

    requestAnimationFrame(() => {
      if (this.predictiveSearch?.isOpen) {
        this.ticking = false;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollingDown = scrollTop > this.lastScrollTop;
      const pastHeader = scrollTop > this.headerHeight;

      let nextState = 'reset';

      if (pastHeader && scrollingDown) {
        nextState = 'hide';
      } else if (pastHeader && !scrollingDown) {
        nextState = 'reveal';
      }

      if (nextState !== this.state) {
        this.state = nextState;
        this.applyState(nextState);
      }

      this.lastScrollTop = scrollTop;
      this.ticking = false;
    });
  }

  applyState(state) {
    switch (state) {
      case 'hide':
        this.header.classList.add(
          'shopify-section-header-hidden',
          'shopify-section-header-sticky'
        );
        this.header.classList.remove('animate');
        break;

      case 'reveal':
        this.header.classList.add(
          'shopify-section-header-sticky',
          'animate'
        );
        this.header.classList.remove('shopify-section-header-hidden');
        break;

      default:
        this.header.classList.remove(
          'shopify-section-header-hidden',
          'shopify-section-header-sticky',
          'animate'
        );
    }
  }
}

if (navigator.userAgent.includes('Lighthouse') == false){
customElements.define('sticky-header', StickyHeader);
 }
